import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}

const teamMembers = [
  {
    name: 'Michael Lutz',
    role: 'Director and Teaching Staff',
    description: 'Michael conducts Aviation-NLP research for NASA Ames, has four AI publications, and works at world-class RL labs at Berkeley.',
    imageSrc: `${process.env.REACT_APP_CLOUDFLARE_URL}/big mike.jpg`,
    imageAlt: 'Michael Lutz',
  },
  {
    name: 'Saurav Kumar',
    role: 'Director and Teaching Staff',
    description: 'Saurav researched distributed AI at a Stanford Medicine lab, wrote RL algorithms used in AMD chips, and goes to UIUC for CS and Physics.',
    imageSrc: `${process.env.REACT_APP_CLOUDFLARE_URL}/saurav.jpg`,
    imageAlt: 'Saurav Kumar',
  },
  {
    name: 'Arjun Rajaram',
    role: 'Director and Teaching Staff',
    description: 'Arjun taught an ML course to 26k online students, worked in UCSC labs on Biomedical Image Analysis, and cofounded the Student Machine Learning Coalition.',
    imageSrc: `${process.env.REACT_APP_CLOUDFLARE_URL}/arjun.jpeg`,
    imageAlt: 'Arjun Rajaram',
  },
  {
    name: 'Amisha Kumar',
    role: 'Research Mentor',
    description: 'A graduate of Case Western, Amisha is currently attending med school. She conducts bio and medical research with Nobel Laureates at Stanford and Harvard.',
    imageSrc: `${process.env.REACT_APP_CLOUDFLARE_URL}/amisha.jpg`,
    imageAlt: 'Amisha Kumar',
  },
  {
    name: 'Rishi Jain',
    role: 'Research Mentor',
    description: 'Rishi is a computer science student at Berkeley focused on AI research. His current focus includes reinforcement learning for task generalization, parameter-efficient tuning of foundational models, and medical speech science.',
    imageSrc: `${process.env.REACT_APP_CLOUDFLARE_URL}/rishi.jpg`,
    imageAlt: 'Rishi Jain',
  },
  {
    name: 'Anushka Mukhopadhyay',
    role: 'Research Mentor',
    description: 'Anushka studies EECS at UC Berkeley. She has used ML to find natural disasters with NLP, create a suicide prevention app, and classify recyclables. She is passionate about increasing diversity in ML.',
    imageSrc: `${process.env.REACT_APP_CLOUDFLARE_URL}/anushka_mentor.jpg`,
    imageAlt: 'Anushka Mukhopadhyay',
  },
  {
    name: 'Salar Cheema',
    role: 'Research Mentor',
    description: 'Salar studies CS and Statistics at UIUC. He has experience working at Amazon, teaching competitive math, and has won awards for his robotic AI systems.',
    imageSrc: `${process.env.REACT_APP_CLOUDFLARE_URL}/salar.jpeg`,
    imageAlt: 'Salar Cheema',
  },
  {
    name: 'Rithvik Vanga',
    role: 'Research Mentor',
    description: 'Rithvik studies Computer Science and Business at the University of Michigan. He has been a leader for his Robotics team, winning State and qualifying for Worlds 5 years in a row.',
    imageSrc: `${process.env.REACT_APP_CLOUDFLARE_URL}/rith.jpg`,
    imageAlt: 'Rithvik Vanga',
  },
  {
    name: 'Nishkal Hundia',
    role: 'AI Fellow',
    description: 'Nishkal studies AI at the University of Maryland. A part of BLAST AI\'s 2022 cohort, he co-first authored a research paper on Genotype Imputation - his model beat accuracies of Stanford PhDs.',
    imageSrc: `${process.env.REACT_APP_CLOUDFLARE_URL}/nishkal.jpg`,
    imageAlt: 'Nishkal Hundia',
  },
  {
    name: 'Shrey Dhingra',
    role: 'Research Mentor',
    description: 'Conducts advanced research at UMass and architects hackathons at Trent University. An award-winning competitor at international science fairs and Robotics Championships, passionate about translating high-level tech research into student success. Currently building the core curriculum at KometAI.org to help young builders master the co-pilot era.',
    imageSrc: `${process.env.PUBLIC_URL}/shreyansh.png`,
    imageAlt: 'Shrey Dhingra',
  },
  {
    name: 'Tarun Dhingra',
    role: 'Research Mentor',
    description: 'Launches successful global businesses and architects government-level education initiatives. As an early pioneer of classroom hardware and a veteran mentor for elite robotics and international science fair teams, he is passionate about translating industry-leading innovations into student success. Currently guiding the next generation at KometAI.org to master the co-pilot era.',
    imageSrc: `${process.env.PUBLIC_URL}/tarun.png`,
    imageAlt: 'Tarun Dhingra',
  },
  {
    name: 'Arav Ahuja',
    role: 'Research Mentor',
    description: 'Business strategist and AI mentor translating complex tech into intuitive, real-world playgrounds to build the next generation of digital leaders. Leveraging business experience to teach practical, future-proof problem solving and equip the next generation with the AI fluency and entrepreneurial mindset required to build the future. Launching his own cohort at KometAI.org.',
    imageSrc: `${process.env.PUBLIC_URL}/arav.png`,
    imageAlt: 'Arav Ahuja',
  },
  // {
  //   name: 'Felipe Caceres-Fernandez',
  //   role: 'AI Fellow',
  //   description: 'Felipe designed mechanisms for a world class FRC robotics team, founded his own engineering outreach organization, and will be attending Carnegie Mellon University in the fall of 2024.',
  //   imageSrc: `${process.env.REACT_APP_CLOUDFLARE_URL}/felipe.jpg`,
  //   imageAlt: 'Felipe Caceres-Fernandez',
  // },
];

class Team extends React.Component {

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,      
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      pushLeft,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'team section center-content',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'team-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const tilesClasses = classNames(
      'tiles-wrap',
      pushLeft && 'push-left'
    );

    const sectionHeader = {
      title: 'Meet The Team',
      // paragraph: 'BLAST is led by researchers and industry profressionals from top CS universities. We know how to help students conduct research.'
    };

    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container">
          <div className={innerClasses}>
            {/* <SectionHeader data={sectionHeader} className="center-content reveal-from-bottom" /> */}
            <div className={tilesClasses}>

            <div className={tilesClasses}>
              {teamMembers.map((member, index) => (
                <div key={index} className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay={index * 150}>
                  <div className="tiles-item-inner">
                    <div className="team-item-header">
                      <div className="team-item-image mb-24 rounded-full" style={{ width: 180, height: 180, overflow: 'hidden', borderRadius: '50%', margin: '0 auto' }}>
                        <Image
                          src={member.imageSrc}
                          alt={member.imageAlt}
                          width={180}
                          height={180}
                          className="rounded-full"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                      </div>
                    </div>
                    <div className="team-item-content">
                      <h5 className="team-item-name mt-0 mb-4">
                        {member.name}
                      </h5>
                      <div className="team-item-role text-xs fw-600 mb-8">
                        {member.role}
                      </div>
                      <p className="m-0 text-sm">
                        {member.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
             
            </div>
          </div>
        </div>
      </section>
    );
  }
}

Team.propTypes = propTypes;
Team.defaultProps = defaultProps;

export default Team;